
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/sms-privacy-policy",
      function () {
        return require("private-next-pages/support/sms-privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/sms-privacy-policy"])
      });
    }
  